import BasketView from '@/views/BasketView.vue';
import HomeView from '@/views/HomeView.vue';
import NotFoundView from '@/views/NotFoundView.vue';
import OrderPlacedView from '@/views/OrderPlacedView.vue';
import OrderView from '@/views/OrderView.vue';
import PlaceOrderView from '@/views/PlaceOrderView.vue';
import ActionsView from '@/views/ActionsView.vue';

import ProductDetailView from '@/views/ProductDetails.vue';

import InvoiceView from '@/views/InvoiceView.vue';
import DownloadInvoiceView from '@/views/DownloadInvoiceView.vue';

import ReceiptView from '@/views/ReceiptView.vue';
import DownloadReceiptView from '@/views/DownloadReceiptView.vue';

export default [
  {
    component: HomeView,
    name: 'Home',
    path: '/',
  },
  {
    component: BasketView,
    name: 'Basket',
    path: '/basket',
  },
  {
    component: ProductDetailView,
    name: 'Product Detail',
    path: '/product/:id',
  },
  {
    component: OrderPlacedView,
    name: 'OrderPlaced',
    path: '/order-placed',
  },
  {
    component: PlaceOrderView,
    name: 'PlaceOrder',
    path: '/place-order',
  },
  {
    component: OrderView,
    name: 'OrderView',
    path: '/:id/orders',
  },
  // {
  //   path: '/',
  //   component: MainLayout,
  //   children: [
  //   ],
  // },
  {
    component: InvoiceView,
    name: 'Invoice',
    path: '/invoice/:id',
  },
  {
    component: DownloadInvoiceView,
    name: 'Download Invoice',
    path: '/invoice/:id/download',
  },
  {
    component: ReceiptView,
    name: 'Receipt',
    path: '/receipt/:id',
  },
  {
    component: DownloadReceiptView,
    name: 'Download Receipt',
    path: '/receipt/:id/download',
  },
  {
    component: ActionsView,
    name: 'Actions',
    path: '/actions',
  },
  {
    component: NotFoundView,
    meta: {
      requiresAuth: false,
    },
    name: 'Not Found',
    path: '/:pathMatch(.*)*',
  },

];
